import { CampagneModel } from "@/app/entities";
import { CampagneFilterDataModel } from "@/components";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { format, parse } from "date-fns";
import frLocale from "date-fns/locale/fr";

export type CampagneStoreType = {
  savedCampagnes: CampagneModel[];
  campagnes: CampagneModel[];
  paginatedItems: {
    content: CampagneModel[];
    empty: boolean;
    first: boolean;
    last: boolean;
    number: number;
    numberOfElements: number;
    pageable: any;
    size: number;
    sort: any;
    totalElements: number;
    totalPages: number;
  };
  filterForm: CampagneFilterDataModel;
  filterCampagnes: (filterForm: CampagneFilterDataModel) => CampagneModel[];
  setCampagnes: (campagnes: CampagneModel[]) => void;
  setPaginatedItems: (data: any) => void;
  setFilterForm: (filterForm: CampagneFilterDataModel) => void;
  clearStore: () => void;
};

export const useCampagneStore = create<CampagneStoreType>()(
  persist(
    (set, get) => ({
      campagnes: [],
      savedCampagnes: [],
      paginatedItems: {
        content: [],
        empty: true,
        first: true,
        last: true,
        number: 0,
        numberOfElements: 0,
        pageable: {},
        size: 0,
        sort: {},
        totalElements: 0,
        totalPages: 0,
      },
      filterForm: { type: "", creationDate: "", draft: "", shelve: "" },
      setFilterForm: (filterForm: CampagneFilterDataModel) => {
        set((state) => ({
          ...state,
          filterForm,
          // campagnes: state.filterCampagnes(filterForm),
        }));
      },
      filterCampagnes: (filterForm: CampagneFilterDataModel) => {
        let _campagnes = [...get().savedCampagnes];
        if (filterForm.type.trim()) {
          _campagnes = _campagnes.filter(
            (campagne: CampagneModel) =>
              campagne.typeCampagne === filterForm.type
          );
        }

        if (filterForm.creationDate.trim()) {
          const canUseCreationDateFilter = format(
            parse(filterForm.creationDate.trim(), "dd/MM/yyyy", new Date()),
            "dd LLLL yyyy",
            { locale: frLocale }
          );
          _campagnes = _campagnes.filter((campagne: CampagneModel) => {
            return (campagne.dateCreation ?? "").includes(
              canUseCreationDateFilter
            );
          });
        }

        const canUseDraftFilter =
          filterForm.draft && filterForm.draft !== "null";
        if (canUseDraftFilter) {
          _campagnes = _campagnes.filter((campagne: CampagneModel) => {
            const filterFormDraft: boolean = filterForm.draft === "OUI";
            return campagne.draft === filterFormDraft;
          });
        }

        const canUseShelveFilter =
          filterForm.shelve && filterForm.shelve !== "null";
        if (canUseShelveFilter) {
          _campagnes = _campagnes.filter((campagne: CampagneModel) => {
            const filterFormShelve: boolean = filterForm.shelve === "OUI";
            return campagne.shelve === filterFormShelve;
          });
        }

        return _campagnes;
      },
      setCampagnes: (campagnes: CampagneModel[]) => {
        set((state) => ({ ...state, campagnes, savedCampagnes: campagnes }));
      },
      setPaginatedItems: (data: any) => {
        set((state) => ({
          ...state,
          paginatedItems: { ...data },
        }));
      },
      clearStore: () => {
        set({
          campagnes: [],
          savedCampagnes: [],
          filterForm: { type: "", creationDate: "", draft: "", shelve: "" },
        });
        localStorage.removeItem("campagne-store");
      },
    }),
    {
      name: "campagne-store",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
